import React from "react";
import { useNavigate } from 'react-router-dom';
import { Vacancy } from "../../types";

type BasicVacancyCardProps = {
  vacancy: Vacancy,
  children?: React.ReactNode,
}

export const BasicVacancyCard = ({ vacancy, children } : BasicVacancyCardProps) => {
  const navigate = useNavigate();

  const vacancyHandler = () => {
      navigate(`/vacancy/${vacancy.id}`);
      sessionStorage.setItem("scrollPosition", JSON.stringify(window.scrollY));
  }

  return(
    <div className="VacansyCardEmployer">
      <div onClick={vacancyHandler} style={{cursor: 'pointer'}}>
        <div className="header-card" style={{marginBottom: '8px'}}>
          <h1 className="name-vacancyCard"> {vacancy.name} </h1>
          {(vacancy.isProbation) && <div className="probation-vacancyCard"> Стажировка </div>}
        </div>
        <h3 className="salary-vacancyCard"> {vacancy.salary} </h3>
        <h2 className="companyName-vacancyCard"> {vacancy.companyName} </h2>
        <p> {vacancy.description} </p>
      </div>
      {children}
    </div>
  )
}